export default __webpack_public_path__ + "static/media/cover.3064fca3.svg";